import {SetStateAction, useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Form} from "react-bootstrap";
import {UserService} from "./Service";
import {toast} from "react-hot-toast";


const CreateUserRole = () => {
    const company = useSelector((state: any) => state.company);
    const [name, setName] = useState('');
    const [modules, setModules] = useState<any[]>([]);
    const [service] = useState(new UserService());

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const _modules: any[] = [];
        modules.map((module: any) => {
            if (module.read || module.write || module.update || module.delete || module.download) {
                _modules.push({
                    id: module.id,
                    read: module.read,
                    write: module.write,
                    update: module.update,
                    delete: module.delete,
                    download: module.download,
                });
            }
        });
        const res = await service.createRole({
            name: name,
            modules: _modules
        });
        if (res != null) {
            toast.success('Role created successfully');
            setName('');
            initModules();
        }
    }

    const initModules = () => {
        const _modules: SetStateAction<any[]> = [];
        const _reads: SetStateAction<any[]> = [];
        company.assignedModules.map((module: any) => {
            _modules.push({
                ...module,
                read: false,
                write: false,
                update: false,
                delete: false,
                download: false,
                all: false,
            });
            _reads.push(false);
        });
        setModules(_modules);
    }

    useEffect(() => {
        initModules();
    }, []);

    useEffect(() => {
        console.log(modules);
    }, [modules]);

    return (
        <>
            <div className="card mb-0">
                <div className="card-body">
                    <div className="page-header">
                        <div className="content-page-header">
                            <h5>Create new Role</h5>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit} className="row">
                        <div className="col-12">
                            <div className="input-block mb-3">
                                <label>Name <span className="text-danger">(required)</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Role name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required={true}
                                />
                            </div>
                        </div>
                        <div className="table-responsive w-100 col-12 mb-5">
                            <table
                                id="items"
                                className="table datatable  w-100"
                            >
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Module</th>
                                    <th>Parent Module</th>
                                    <th>Read</th>
                                    <th>Write</th>
                                    <th>Update</th>
                                    <th>Delete</th>
                                    <th>Download</th>
                                    <th>All</th>
                                </tr>
                                </thead>
                                <tbody>
                                {modules.map((module: any, index: number) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{module.name}</td>
                                        <td>{module.parent != null ? module.parent.name : ''}</td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.read}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].read = e.target.checked;
                                                    if (!_modules[index].read) {
                                                        _modules[index].all = false;
                                                    } else if (_modules[index].read && _modules[index].write && _modules[index].update && _modules[index].delete && _modules[index].download) {
                                                        _modules[index].all = true;
                                                    }
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.write}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].write = e.target.checked;
                                                    if (!_modules[index].write) {
                                                        _modules[index].all = false;
                                                    } else if (_modules[index].read && _modules[index].write && _modules[index].update && _modules[index].delete && _modules[index].download) {
                                                        _modules[index].all = true;
                                                    }
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.update}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].update = e.target.checked;
                                                    if (!_modules[index].update) {
                                                        _modules[index].all = false;
                                                    } else if (_modules[index].read && _modules[index].write && _modules[index].update && _modules[index].delete && _modules[index].download) {
                                                        _modules[index].all = true;
                                                    }
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.delete}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].delete = e.target.checked;
                                                    if (!_modules[index].delete) {
                                                        _modules[index].all = false;
                                                    } else if (_modules[index].read && _modules[index].write && _modules[index].update && _modules[index].delete && _modules[index].download) {
                                                        _modules[index].all = true;
                                                    }
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.download}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].download = e.target.checked;
                                                    if (!_modules[index].download) {
                                                        _modules[index].all = false;
                                                    } else if (_modules[index].read && _modules[index].write && _modules[index].update && _modules[index].delete && _modules[index].download) {
                                                        _modules[index].all = true;
                                                    }
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <Form.Check // prettier-ignore
                                                type={'checkbox'}
                                                checked={module.all}
                                                onChange={(e) => {
                                                    const _modules = [...modules];
                                                    _modules[index].all = e.target.checked;
                                                    _modules[index].read = e.target.checked;
                                                    _modules[index].write = e.target.checked;
                                                    _modules[index].update = e.target.checked;
                                                    _modules[index].delete = e.target.checked;
                                                    _modules[index].download = e.target.checked;
                                                    setModules(_modules);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-12">
                            <div className="btn-path text-end">
                                <a
                                    href="javascript:void(0);"
                                    className="btn btn-cancel bg-primary-light me-3"
                                    onClick={() => {
                                        setName('');
                                        initModules();
                                    }}
                                >
                                    Cancel
                                </a>
                                <button type="submit" className="btn btn-primary">
                                    Save Changes
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default CreateUserRole;
